<script setup>
import { defineProps, computed} from "vue";
import TabelaDeVinculos from "./TabelaDeVinculos/TabelaDeVinculos.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "recebimento",
]);

//==================================================================//
//========================= Mostra Vinculos ========================//
//==================================================================//

let mostraVinculos = computed(()=>{

    if(props?.recebimento?.vinculos?.length <= 0){
        return false;
    }

    if(props?.recebimento?.aberto == false){
        return false;
    }

    return true;

});

</script>

<template>

    <div
        class="c-table__row"
        v-show="mostraVinculos"
    >

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <TabelaDeVinculos
                    :dado="props?.dado"
                    :recebimento="props?.recebimento"
                ></TabelaDeVinculos>

            </div>

        </div>

    </div>

</template>

<style scoped>

.c-table__row{
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.c-table__row:hover{
    background-color: #eeeeee;
}

.c-table__cell{
    grid-column: 3 / -1;
}

</style>
